import React from 'react';
interface Column<T> {
  header: string;
  accessor: keyof T | ((item: T) => React.ReactNode);
  className?: string;
}
interface TableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?: (item: T) => void;
  keyField: keyof T;
  emptyMessage?: string;
}
export function Table<T>({
  data,
  columns,
  onRowClick,
  keyField,
  emptyMessage = 'No data available'
}: TableProps<T>) {
  if (data.length === 0) {
    return <div className="text-center py-12 bg-white rounded-lg border border-gray-200" data-id="element-307">
        <p className="text-gray-500" data-id="element-308">{emptyMessage}</p>
      </div>;
  }
  return <div className="overflow-x-auto rounded-lg border border-gray-200" data-id="element-309">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-310">
        <thead className="bg-gray-50" data-id="element-311">
          <tr data-id="element-312">
            {columns.map((col, idx) => <th key={idx} scope="col" className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${col.className || ''}`} data-id="element-313">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-314">
          {data.map(item => <tr key={String(item[keyField])} onClick={() => onRowClick && onRowClick(item)} className={onRowClick ? 'cursor-pointer hover:bg-gray-50 transition-colors' : ''} data-id="element-315">
              {columns.map((col, idx) => <td key={idx} className={`px-6 py-4 whitespace-nowrap text-sm text-gray-900 ${col.className || ''}`} data-id="element-316">
                  {typeof col.accessor === 'function' ? col.accessor(item) : item[col.accessor] as React.ReactNode}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}